import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PermissionsEnum } from '../../../api/api-reference';
import { AuthService } from '../../../services/auth.service';
import { LanguageService } from '../../../services/language.service';
import { Language } from '../../core/enums/lanugage.enum';

@Component({
  selector: 'app-account-language',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './account-language.component.html',
  styleUrl: './account-language.component.scss',
})
export class AccountLanguageComponent {
  Language = Language;
  PermissionsEnum = PermissionsEnum;
  selectedLanguage = '';

  constructor(
    private languageService: LanguageService,
    public authService: AuthService,
  ) {
    this.selectedLanguage = this.languageService.getLanguage();
  }

  switchLanguage(language: Language) {
    this.languageService.setLanguage(language);
  }

  onRadioChange(language: Language) {
    this.selectedLanguage = language;

    if (this.selectedLanguage === Language.English) {
      this.switchLanguage(Language.English);
    } else if (this.selectedLanguage === Language.Serbian) {
      this.switchLanguage(Language.Serbian);
    } else if (this.selectedLanguage === Language.German) {
      this.switchLanguage(Language.German);
    } else if (this.selectedLanguage === Language.French) {
      this.switchLanguage(Language.French);
    }
  }
}
